import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {Routes} from '../Routes';
import {LandingScreen, SignInScreen, ResetPasswordScreen,RegisterOrg} from 'screens';
import {displayScreenTitle, landingPageTitle} from 'constants/DefaultValues';

const Stack = createNativeStackNavigator();

export const OutSideStack: React.FC = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name={Routes.HOME}
        component={LandingScreen}
        options={{headerShown: displayScreenTitle, title: landingPageTitle}}
      />
      {/* <Stack.Screen
        name={Routes.LOGIN}
        component={SignInScreen}
        options={{headerShown: displayScreenTitle, title: landingPageTitle}}
      /> */}
      <Stack.Screen
        name={Routes.SIGN_UP}
        component={RegisterOrg}
        options={{headerShown: displayScreenTitle, title: landingPageTitle}}
      />
      {/* <Stack.Screen
        name={Routes.FORGOT_PASSWORD_PRE_LOGIN}
        options={{headerShown: displayScreenTitle, title: landingPageTitle}}>
        {props => <ResetPasswordScreen {...props} mode="forgot" />}
      </Stack.Screen> */}
    </Stack.Navigator>
  );
};
